import { HiCheckBadge } from "react-icons/hi2";

export const LicensesIcon = ({ width, height, color, ...props }) => (
  <HiCheckBadge
    size={width || height || 14}
    color={color || "currentColor"}
    {...props}
  />
);
